import ruAuth from './locales/ru/auth.js'
import ruBeauty from './locales/ru/beauty.js'
import ruCabinet from './locales/ru/cabinet.js'
import ruCommon from './locales/ru/common.js'
import ruEcommerce from './locales/ru/ecommerce.js'
import ruEntities from './locales/ru/entities.js'
import ruFooter from './locales/ru/footer.js'
import ruHeader from './locales/ru/header.js'
import ruLanding from './locales/ru/landing.js'
import ruNotifications from './locales/ru/notifications.js'
import ruPages from './locales/ru/pages.js'
import ruProfileDeleteModal from './locales/ru/profileDeleteModal.js'
import ruProjectCreateModal from './locales/ru/projectCreateModal.js'
import ruRates from './locales/ru/rates.js'
import ruValidation from './locales/ru/validation.js'

import enAuth from './locales/en/auth.js'
import enBeauty from './locales/en/beauty.js'
import enCabinet from './locales/en/cabinet.js'
import enCommon from './locales/en/common.js'
import enEcommerce from './locales/en/ecommerce.js'
import enEntities from './locales/en/entities.js'
import enFooter from './locales/en/footer.js'
import enHeader from './locales/en/header.js'
import enLanding from './locales/en/landing.js'
import enNotifications from './locales/en/notifications.js'
import enPages from './locales/en/pages.js'
import enProfileDeleteModal from './locales/en/profileDeleteModal.js'
import enProjectCreateModal from './locales/en/projectCreateModal.js'
import enRates from './locales/en/rates.js'
import enValidation from './locales/en/validation.js'

import kaAuth from './locales/ka/auth.js'
import kaBeauty from './locales/ka/beauty.js'
import kaCabinet from './locales/ka/cabinet.js'
import kaCommon from './locales/ka/common.js'
import kaEcommerce from './locales/ka/ecommerce.js'
import kaEntities from './locales/ka/entities.js'
import kaFooter from './locales/ka/footer.js'
import kaHeader from './locales/ka/header.js'
import kaLanding from './locales/ka/landing.js'
import kaNotifications from './locales/ka/notifications.js'
import kaPages from './locales/ka/pages.js'
import kaProfileDeleteModal from './locales/ka/profileDeleteModal.js'
import kaProjectCreateModal from './locales/ka/projectCreateModal.js'
import kaRates from './locales/ka/rates.js'
import kaValidation from './locales/ka/validation.js'

import uzAuth from './locales/uz/auth.js'
import uzBeauty from './locales/uz/beauty.js'
import uzCabinet from './locales/uz/cabinet.js'
import uzCommon from './locales/uz/common.js'
import uzEcommerce from './locales/uz/ecommerce.js'
import uzEntities from './locales/uz/entities.js'
import uzFooter from './locales/uz/footer.js'
import uzHeader from './locales/uz/header.js'
import uzLanding from './locales/uz/landing.js'
import uzNotifications from './locales/uz/notifications.js'
import uzPages from './locales/uz/pages.js'
import uzProfileDeleteModal from './locales/uz/profileDeleteModal.js'
import uzProjectCreateModal from './locales/uz/projectCreateModal.js'
import uzRates from './locales/uz/rates.js'
import uzValidation from './locales/uz/validation.js'

export default defineI18nConfig(() => ({
  legacy: false,
  flatJson: true,
  messages: {
    ru: {
      ...ruAuth,
      ...ruBeauty,
      ...ruCabinet,
      ...ruCommon,
      ...ruEcommerce,
      ...ruEntities,
      ...ruFooter,
      ...ruHeader,
      ...ruLanding,
      ...ruNotifications,
      ...ruPages,
      ...ruProfileDeleteModal,
      ...ruProjectCreateModal,
      ...ruRates,
      ...ruValidation,
    },
    en: {
      ...enAuth,
      ...enBeauty,
      ...enCabinet,
      ...enCommon,
      ...enEcommerce,
      ...enEntities,
      ...enFooter,
      ...enHeader,
      ...enLanding,
      ...enNotifications,
      ...enPages,
      ...enProfileDeleteModal,
      ...enProjectCreateModal,
      ...enRates,
      ...enValidation,
    },
    ka: {
      ...kaAuth,
      ...kaBeauty,
      ...kaCabinet,
      ...kaCommon,
      ...kaEcommerce,
      ...kaEntities,
      ...kaFooter,
      ...kaHeader,
      ...kaLanding,
      ...kaNotifications,
      ...kaPages,
      ...kaProfileDeleteModal,
      ...kaProjectCreateModal,
      ...kaRates,
      ...kaValidation,
    },
    uz: {
      ...uzAuth,
      ...uzBeauty,
      ...uzCabinet,
      ...uzCommon,
      ...uzEcommerce,
      ...uzEntities,
      ...uzFooter,
      ...uzHeader,
      ...uzLanding,
      ...uzNotifications,
      ...uzPages,
      ...uzProfileDeleteModal,
      ...uzProjectCreateModal,
      ...uzRates,
      ...uzValidation,
    },
  },
  pluralizationRules: {
    ru: (choice: number) => {
      if (choice === 0) return 0

      const teen = choice % 100 >= 11 && choice % 100 <= 19
      const endsWithOne = choice % 10 === 1
      const endsWithTwoToFour = choice % 10 >= 2 && choice % 10 <= 4

      if (!teen && endsWithOne) return 1

      if (!teen && endsWithTwoToFour) return 2

      return 3
    }
  },
}))
